import { capitalise, snakeToReadable } from "@/utils/textUtilities";
import { isPlainObject } from "lodash";

export function filterChecks(obj) {
    if (!isPlainObject(obj)) return obj;
    return Object.entries(obj)
        .filter(([key, value]) => !!value)
        .map(([key, value]) => keyToText(key));
}

export function keyToText(key) {
    switch (key) {
        case "email_address":
            return "Email";
        case "name":
            return "Name";
        case "phone_number":
            return "Phone Number";
        case "user_name":
            return "Username";
        case "personal_number":
            return "Personal Number";
        case "credit_card_numbers":
            return "Credit Card Numbers";
        case "billing_address":
            return "Billing Address";
        case "tax_number":
            return "Tax Number";
        case "authentication":
            return "Authentication Data";
        case "ci":
            return "CI codes (click tracking)";
        case "isc":
            return "ISC (source tracking)";
        case "itc":
            return "ITC (item tracking codes)";
        case "phone_model":
            return "Phone model";
        case "device_id":
            return "Device ID";
        case "customer_number":
            return "Customer number";
        case "browser_type":
            return "Browser type";
        case "isp":
            return "Internet service provider (ISP)";
        case "exit_pages":
            return "Referring/exit pages";
        case "operating_system":
            return "Operating system";
        case "time_stamp":
            return "Date/time stamp";
        case "clickstream_data":
            return "Clickstream data";
        case "geo_data":
            return "Geo-location data";
        case "usage_info":
            return "Usage information with Google Analytics";
        case "personal_info":
            return "Publicly available personal information";
        case "":
            return "";
        default:
            return capitalise(snakeToReadable(key));
    }
}
